package ca.derekellis.reroute.db

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import ca.derekellis.reroute.db.web.newInstance
import ca.derekellis.reroute.db.web.schema

public interface RerouteDatabase : SuspendingTransacter {
  public val metadataQueries: MetadataQueries

  public val stopSearchQueries: StopSearchQueries

  public val stopsQueries: StopsQueries

  public companion object {
    public val Schema: SqlSchema
      get() = RerouteDatabase::class.schema

    public operator fun invoke(driver: SqlDriver, MetadataAdapter: Metadata.Adapter):
        RerouteDatabase = RerouteDatabase::class.newInstance(driver, MetadataAdapter)
  }
}
